import { useMemo } from "react";
import { PAGE_REPORTS } from "./pageReports";
import { REPORTS, ReportDefinition } from "./reports";

export type ReportOption = {
  id: string;
  label: string;
  disabled?: boolean;
};


export function useAvailableReports(
  page: string,
  availability: Record<string, boolean> = {}
): ReportOption[] {
  return useMemo(() => {
    const pageReportIds = PAGE_REPORTS[page] || [];

    return pageReportIds
      .map((id) => {
        const report = REPORTS[id];

        if (!report) return null;

         const isEnabled = availability[id] === true;

        return {
          id: report.id,
          label: report.label,
          // disabled by default, enabled only if key exists
          disabled: !isEnabled,
        };
      })
      .filter(Boolean) as ReportOption[];
  }, [page, availability]);
}